import React from 'react';
import moment from 'moment';
import SurveyComponent from 'pages/RMO/components/cancerTemplate/Template';
import PatientDetailsPrintHeader from 'components/CommonPrintComponent/PatientDetailsPrintHeader';
import { MocUserRole } from 'core/services/models/Enums';

export default function DietPlanPrint({
  dietPlanDetails,
  componentRef,
  signatureJson,
  signatureData,
  patientDetail,
  vitalsData,
  smartSummaryData,
  appointmentDate
}: any) {

  const formatText = (inputText: any) => {
    const lines = inputText?.split('\n');
    return lines?.map((line: any, index: any) => (
      <React.Fragment key={index}>
        {line}
        {index !== lines.length - 1 && <br />}
      </React.Fragment>
    ));
  }

  return (
    <div
      className="prescriptions-print-wrapper"
      ref={componentRef}
    >
      {/* Patient Details */}
      <PatientDetailsPrintHeader
        patientData={{ patientInfo: patientDetail, vitalsData: vitalsData }}
        origin={MocUserRole.NUTRITIONIST}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDate}
      />
      <br />
      {/* Medical Comorbidities */}
      <div className="heading-primary-text">Medical Comorbidities :</div>
      <div className="textarea-content">
        {
          formatText(dietPlanDetails?.medicalComorbidities)
        }
      </div><br />
      {/* Diet Modifications : */}
      <div className="heading-primary-text">Diet Modifications :</div>
      <div className="textarea-content">
        {
          formatText(dietPlanDetails?.dietModifications)
        }
      </div><br />
      {/* Clinical Impressions */}
      <div className="heading-primary-text">Diet Advised :</div>
      <div className="textarea-content">
        {
          formatText(dietPlanDetails?.dietAdviced)
        }
      </div><br />
      {/* Diet Plan Details */}
      <div className='row'>
        <div className="col-md-2 heading-primary-text">Diet Plan</div>
        <div className="col-md-2 heading-primary-text">Calories</div>
        <div className="col-md-2 heading-primary-text">Proteins</div>
        <div className="col-md-2 heading-primary-text">Fat</div>
        <div className="col-md-2 heading-primary-text">FFD</div>
      </div>
      <br />
      <div className='row'>
        <div className="col-md-2 textarea-content">{dietPlanDetails?.dietPlanData?.dietPlan}</div>
        <div className="col-md-2 textarea-content">{dietPlanDetails?.dietPlanData?.calories}</div>
        <div className="col-md-2 textarea-content">{dietPlanDetails?.dietPlanData?.proteins}</div>
        <div className="col-md-2 textarea-content">{dietPlanDetails?.dietPlanData?.fat}</div>
        <div className="col-md-2 textarea-content">{dietPlanDetails?.dietPlanData?.ffd}</div>
      </div>
      {/* Meal Plan Details */}
      < section className="chemo-order">
        <div className="chemo-order-details">
          <div className="pre-medication-container">
            <table className="pre-medication-table-container">
              <thead>
                <th>Meal</th>
                <th>Time</th>
                <th>Menu</th>
              </thead>
              <tbody>
                {
                  dietPlanDetails?.dietPlanData?.mealPlan?.length > 0 ? (
                    dietPlanDetails?.dietPlanData?.mealPlan?.map((e: any) => (
                      <tr className="procedure-data">
                        <td>{e?.meal}</td>
                        <td>{e?.time}</td>
                        <td className='diet-plan-print-menu'>{e?.menu}</td>
                      </tr>
                    ))
                  ) : <p>NA</p>
                }
              </tbody>
            </table>
          </div>
        </div>
        <br />
      </section>
      <br />
      <div className="heading-primary-text">Nutritional Remarks :</div>
      <div>
        {
          formatText(dietPlanDetails?.nutritionalRemarks)
        }
      </div><br />
      <div className="heading-primary-text">Dietician Incharge</div>
      <div className='row'>
        <div className="col-md-3 heading-primary-text">Name</div>
        <div className="col-md-3 heading-primary-text">Date/Time</div>
        <div className="col-md-3 heading-primary-text">Emp No</div>
      </div>
      <div className='row'>
        <div className="col-md-3 textarea-content">{dietPlanDetails?.dieticianName}</div>
        <div className="col-md-3 textarea-content">
          {dietPlanDetails?.dateTime
            ? moment(dietPlanDetails?.dateTime).format(
              "DD-MM-YYYY / HH:mm a"
            )
            : ""}
        </div>
        <div className="col-md-3 textarea-content">{dietPlanDetails?.dieticianEmpNo}</div>
      </div>
      <br />
      <div>
        <SurveyComponent
          css={""}
          data={signatureData}
          json={signatureJson}
          onComplete={(survey: any) => {
            const data = survey.data
          }}
          hideDot={true}
        />
      </div>
    </div >
  )
}
